export const uploadClasses = {
  upload: 'me__upload',
  uploadBox: 'me__upload__box',
  uploadAvatar: 'me__upload__avatar',
  uploadSinglePreview: 'me__upload__single__preview',
  uploadMultiPreview: 'me__upload__multi__preview',
  uploadRejectionFiles: 'me__upload__rejection__files',
};
